import React from 'react';
import {connect} from 'react-redux';
import {toggleDrawingPanel} from '../../../Redux/actions/ui.js';
import { selectPermissionCapabilities } from '../../../utils/permissions.js';

class ViewerControls extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      intervalID:null,
      labelsIntervalID:null,
      cameraDirection:0,
      rulerEnabled:false,
      areaModeEnabled:false,
			isRecording: false,
      markersVisible: false,
      labelsVisible: {
        screen: false,
        world: false,
        static: false,
        all: false
      },
      anySceneStateEnabled: {
        labels: false,
        markers: false
      }
    };
    this.getCameraDirection = this.getCameraDirection.bind(this);
    this.updateLabelsState = this.updateLabelsState.bind(this);
    this.updateMarkersState = this.updateMarkersState.bind(this);
    this.updateAnySceneStateEnabled = this.updateAnySceneStateEnabled.bind(this);
  }

  componentDidMount() {
    let intervalID = setInterval(() => {
      this.getCameraDirection();
    },500);
    
    // Poll labels state to keep button in sync with scene state changes
    let labelsIntervalID = setInterval(() => {
      this.updateLabelsState();
      this.updateMarkersState();
      this.updateAnySceneStateEnabled();
    }, 200);
    
    this.setState({intervalID, labelsIntervalID});
    
    // Initial updates
    this.updateLabelsState();
    this.updateMarkersState();
    this.updateAnySceneStateEnabled();
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalID);
    clearInterval(this.state.labelsIntervalID);
  }

  getCameraDirection() {
    let angle = Inventum.camera.getCameraYAngle().toFixed(0);
    if (angle == this.state.cameraDirection) {
      return;
    }
    this.setState({cameraDirection:Inventum.camera.getCameraYAngle()})
  }

  updateLabelsState() {
    const newLabelsState = Inventum.labels.getLabelsVisible();
    if (JSON.stringify(newLabelsState) !== JSON.stringify(this.state.labelsVisible)) {
      this.setState({labelsVisible: newLabelsState});
    }
  }

  updateMarkersState() {
    const newMarkersVisible = Inventum.markers.getMarkersVisible();
    if (newMarkersVisible !== this.state.markersVisible) {
      this.setState({markersVisible: newMarkersVisible});
    }
  }

  updateAnySceneStateEnabled() {
    const anyEnabled = Inventum.sceneStates.areAnyLabelsOrMarkersEnabled();
    if (JSON.stringify(anyEnabled) !== JSON.stringify(this.state.anySceneStateEnabled)) {
      this.setState({anySceneStateEnabled: anyEnabled});
    }
  }

  render() {
    let captureScreenshot = () => {
      Inventum.screenshot.capture();
    }

    let toggle3DView = () => {
      Inventum.world.showVisibleStart();
      Inventum.camera.showStartView();
    }

    let toggleHighlight = () => {
      console.log('Highlight not implemented');
    }

    let toggleFullscreen = () => {
      let el = document.documentElement;
      if (!document.fullscreenElement) {
        if (el.requestFullscreen) {
          el.requestFullscreen()
          screen.orientation.lock("landscape");
        }
      }else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
          screen.orientation.unlock()
        }
      }
    }

		const toggleRecording = () => {
			if (!this.state.isRecording) {
				Inventum.video.startRecording();
			}else {
				Inventum.video.stopRecording(this.props.pageTitle);
			}
			this.setState({ isRecording: !this.state.isRecording })
		};

	  const handleRuler = () => {
	    this.setState({rulerEnabled:Inventum.ruler.toggle()});
	  };

	  const handleArea = () => {
	    this.setState({areaModeEnabled:Inventum.ruler.togglePlanar()});
	  };

    const toggleAllLabels = () => {
      Inventum.labels.toggleAllLabels();
      Inventum.markers.toggleAllMarkers(); // Scene-specific marker toggle
      this.setState({
        labelsVisible: Inventum.labels.getLabelsVisible(),
        markersVisible: Inventum.markers.getMarkersVisible()
      });
    };

    const toggleAllLabelsGlobal = () => {
      Inventum.labels.toggleAllLabelsGlobal();
      Inventum.markers.toggleAllMarkersGlobal(); // Global marker toggle (all scenes)
      this.setState({
        labelsVisible: Inventum.labels.getLabelsVisible(),
        markersVisible: Inventum.markers.getMarkersVisible()
      });
    };

		return (
      <div className={"map-vertical-controls" + (this.props.uiHideMode === 'ALL' || this.props.uiHideMode === 'ANIMATION' ? ' hidden' : '')}>
        <div className="map-vertical-button" title={"Return to 3D view"} onClick={toggle3DView}><i className="material-icons notranslate">3d_rotation</i></div>
        <div style={{fontSize:"12px",color:"#FFF",fontFamily:"Sans-Serif"}} className="map-vertical-button" onClick={Inventum.camera.showTopNorth} title={"North Arrow"}><i style={{transition:"none", transform:`rotate(${this.state.cameraDirection}deg)`}} className="material-icons notranslate">arrow_upward</i>N</div>
        {/* <PenToolButton onClick={() => this.props.toggleDrawingPanel()} /> */}
        <RulerButton areaModeEnabled={this.state.areaModeEnabled} handleArea={handleArea} rulerEnabled={this.state.rulerEnabled} handleClick={handleRuler} />
        <LabelsButton 
          labelsVisible={this.state.labelsVisible}
          toggleAll={toggleAllLabels}
          toggleAllGlobal={toggleAllLabelsGlobal}
          markersVisible={this.state.markersVisible}
          anySceneStateEnabled={this.state.anySceneStateEnabled}
        />
				<div className="map-vertical-button" title={"Take a Screenshot"} onClick={captureScreenshot}><i className="material-icons notranslate">photo</i></div>
				{this.props.canCreateVideoRecording ? <div style={this.state.isRecording ? {backgroundColor: "#F00"} : {}} className="map-vertical-button" title={"Superuser Only Beta: Toggle Video Recording"} onClick={toggleRecording}><i className="material-icons notranslate">movie_creation</i></div> : null }
				<div className="map-vertical-button" title={"Toggle Fullscreen"} onClick={toggleFullscreen}><i className="material-icons notranslate">{document.fullscreenElement ? "fullscreen_exit" : "fullscreen"}</i></div>
      </div>
    )
  }
}

function PenToolButton({ onClick }) {
  return (
    <div className="map-vertical-button" title="Toggle Drawing Mode" onClick={onClick}>
      <i className="material-icons notranslate">edit</i>
    </div>
  );
}


function RulerButton(props) {
  return (
    <div className="map-vertical-button-group">
      <div className={"map-vertical-button" + (props.rulerEnabled ? " active" : "")} title={"Toggle Ruler Mode \n* Left Click Create Point\n* Right Click End Ruler"} onClick={props.handleClick}><i className="material-icons notranslate">straighten</i></div>
      {props.rulerEnabled ? <div className={"map-vertical-button" + (props.areaModeEnabled ? " active" : "")}title={"Measure Area"} onClick={props.handleArea} style={{position:"absolute",right:"55px",top:"0px"}}><i className="material-icons notranslate">texture</i></div> : null}
      {props.rulerEnabled ? <div className="map-vertical-button" title={"Clear Rulers"} onClick={Inventum.ruler.clearAll} style={{position:"absolute",right:"110px",top:"0px"}}><i className="material-icons notranslate">delete</i></div> : null}
    </div>
  )
}

function LabelsButton(props) {
  const [isHovered, setIsHovered] = React.useState(false);
  const [hideTimer, setHideTimer] = React.useState(null);
  
  // Constants
  const HOVER_DELAY_MS = 300;
  const INACTIVE_BACKGROUND = "rgba(244, 67, 54, 0.3)"; // Low opacity red when off
  const GLOBAL_BUTTON_POSITION = { position: "absolute", right: "55px", top: "0px" };
  
  const handleMouseEnter = () => {
    if (hideTimer) {
      clearTimeout(hideTimer);
      setHideTimer(null);
    }
    setIsHovered(true);
  };
  
  const handleMouseLeave = () => {
    const timer = setTimeout(() => setIsHovered(false), HOVER_DELAY_MS);
    setHideTimer(timer);
  };
  
  // Active states for both buttons
  const currentActionActive = props.labelsVisible.all && props.markersVisible;
  const globalActionActive = props.anySceneStateEnabled.labels || props.anySceneStateEnabled.markers;
  
  // Helper function to get button style based on active state
  const getInactiveStyle = (isActive) => 
    isActive ? {} : { backgroundColor: INACTIVE_BACKGROUND };
  
  // Helper function to get button className
  const getButtonClass = (isActive) => 
    `map-vertical-button ${isActive ? "active" : "inactive"}`;
  
  return (
    <div className="map-vertical-button-group" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      {/* Current Action Button - Always Visible */}
      <div
        className={getButtonClass(currentActionActive)}
        title="Toggle Labels (Current Scene) and Markers"
        onClick={props.toggleAll}
        style={getInactiveStyle(currentActionActive)}>
        <i className="material-icons notranslate">
          {currentActionActive ? "label_important" : "label_important_outline"}
        </i>
      </div>
      
      {/* Global Action Button - Shows on Hover */}
      {isHovered && (
        <div className="map-vertical-button-group" style={GLOBAL_BUTTON_POSITION}>
          <div
            className={getButtonClass(globalActionActive)}
            title="Toggle All Labels (All Scenes) and All Markers"
            onClick={props.toggleAllGlobal}
            style={getInactiveStyle(globalActionActive)}>
            <i className="material-icons notranslate">
              {globalActionActive ? "label" : "label_off"}
            </i>
          </div>
        </div>
      )}
    </div>
  );
}

let mapStateToProps = (state) => {
  const caps = selectPermissionCapabilities(state);

  return {
    uiHideMode: state.ui.hideMode,
    // Legacy prop name retained for compatibility; capability-based source.
    siteAdmin: caps.canAccessEditorUI,
    canCreateVideoRecording: caps.canCreateVideoRecording,
	  pageTitle: state.sidebarUI.title
  };
}

let mapDispatchToProps = dispatch => ({
	toggleDrawingPanel: () => {
    dispatch(toggleDrawingPanel())
  }
});

const ViewerControlsRedux = connect(mapStateToProps, mapDispatchToProps)(ViewerControls);


export default ViewerControlsRedux;
